<template>
  <div class="time-container" :class="{ error: error }">
    <Datepicker
      class="input-time"
      locale="ja"
      v-model="time"
      :format="timeFormat"
      :minutesIncrement="minutesUpDown"
      :minutesGridIncrement="minutesUpDown"
      :startTime="startTime"
      :minDate="minDate"
      :maxDate="maxDate"
      :minTime="minTime"
      :maxTime="maxTime"
      :textInput="false"
      :disabled="isDisabled"
      :clearable="isClearable"
      autoApply
      keepActionRow
      timePicker
    />
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useConfigStore } from '@/store/config'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default defineComponent({
  setup(props, context) {
    const configStore = useConfigStore()

    const time = computed({
      get() {
        if (typeof props.modelValue === 'string') {
          const times = props.modelValue.split(':')
          if (times.length >= 2) {
            return {
              hours: parseInt(times[0], 10),
              minutes: parseInt(times[1], 10),
              seconds: 0
            }
          }
          return null
        } else {
          return props.modelValue
        }
      },
      set(val: any) {
        if (val && typeof val === 'object') {
          let newHours = Number(val.hours)
          let newMinutes = Number(val.minutes)
          const times = (typeof props.modelValue === 'string') ? props.modelValue.split(':') : []
          if (times.length >= 2) {
            const oldMinutes = parseInt(times[1], 10)
            // console.log('oldMinutes: ' + oldMinutes + ', newMinutes: ' + newMinutes)
            for (let idx = 0; idx < minutesList.value.length - 1; idx++) {
              if (oldMinutes >= minutesList.value[idx] && oldMinutes < minutesList.value[idx + 1]) {
                // console.log('Found: ' + minutesList.value[idx] + '～' + minutesList.value[idx + 1])
                if (val.minutes > oldMinutes) {
                  // console.log('Increment')
                  if (idx == 0 && val.minutes >= minutesList.value[minutesList.value.length - 2]) {
                    // 0以上～15未満の値から、45以上（～60未満）へ変更された場合（実質はDecrement）
                    if (oldMinutes == minutesList.value[0]) {
                      // 元の値がゼロだった場合は45
                      newMinutes = minutesList.value[minutesList.value.length - 2]
                    } else {
                      // 元の値が1～15未満だった場合はゼロ
                      newMinutes = minutesList.value[0]
                    }
                  } else if (val.minutes <= oldMinutes + minutesUpDown.value) {
                    // 分の増分が１つ以内の場合のみカウントアップ
                    newMinutes = minutesList.value[idx + 1]
                  }
                } else if (val.minutes < oldMinutes) {
                  // console.log('Decrement')
                  if (idx == minutesList.value.length - 2 && val.minutes < minutesList.value[1]) {
                    // 45以上（～60未満）の値から、0以上～15未満の値へ変更された場合（実質はIncrement）
                    newMinutes = minutesList.value[0]
                  } else if (val.minutes >= oldMinutes - minutesUpDown.value) {
                    // 分の減分が１つ以内の場合のみカウントダウン
                    newMinutes = minutesList.value[idx - 1]
                  }
                }
                break
              }
            }
          }
          // console.log('=> newMinutes: ' + newMinutes)
          context.emit(
            'update:modelValue',
            String(newHours).padStart(2, '0') + ':' + String(newMinutes).padStart(2, '0') + ':00'
          );
        } else {
          context.emit('update:modelValue', val);
        }
      }
    })
    const timeFormat = ref('HH:mm');

    const minutesUpDown = computed(() => {
      if (typeof props.minutesIncrement === 'undefined' || typeof props.minutesIncrement !== 'number') {
        return configStore.dakokuRound
      }
      return props.minutesIncrement
    })
    const minutesList = computed(() => {
      let retList = []
      const listMax = 60 / minutesUpDown.value
      for (let idx = 0; idx < listMax + 1; idx++) {
        retList.push(minutesUpDown.value * idx)
      }
      return retList
    })

    const isDisabled = computed(() => {
      if (typeof props.disabled === 'undefined' || typeof props.disabled !== 'boolean') {
        // props未指定時
        return false
      }
      return props.disabled
    })

    return {
      time,
      timeFormat,
      minutesUpDown,
      isDisabled,
    }
  },
  props: ['modelValue', 'error', 'minutesIncrement', 'startTime', 'minTime', 'maxTime', 'minDate', 'maxDate', 'disabled', 'isClearable'],
  components: {
    Datepicker
  }
})
</script>
